import * as noticesStore from '@cartwhl/common/stores/noticesStore';

import { isBuiltinFreeCharacterId } from '../../shared/freeCharacterMesh';
import type { MotionEditorState } from '../motionEditorStore';
import { resolveKeyPoseMotionContext } from './keyPoseMotionUtils';

export const KEY_POSE_CHARACTER_SWAP_WARNING_MESSAGE =
  'Swapping to this character will remove your key poses; click the character again if you want to swap and delete the key poses';

type KeyPoseStoreForCharacterSwap = {
  removeKeyPosesForReference: (input: {
    referenceName: string;
  }) => { referenceName: string; count: number } | null;
  saveSceneObjectMotionKeyPoses: (input: {
    sceneID: string;
    referenceName: string;
    timelineIndex: number;
    keyPoses: [];
  }) => Promise<boolean>;
};

export function isKeyPoseEditingSupportedCharacterId(characterID: string) {
  return isBuiltinFreeCharacterId(characterID);
}

export function isKeyPoseCharacterSwapWarningActive() {
  return noticesStore.state.notices.some(
    (notice) =>
      notice.type === 'warning' &&
      notice.message === KEY_POSE_CHARACTER_SWAP_WARNING_MESSAGE,
  );
}

export async function clearKeyPosesForCharacterSwap({
  keyPoseStore,
  motionEditorState,
  referenceName,
}: {
  keyPoseStore: KeyPoseStoreForCharacterSwap;
  motionEditorState: MotionEditorState;
  referenceName: string;
}) {
  const removed = keyPoseStore.removeKeyPosesForReference({ referenceName });
  if (!removed) {
    return;
  }

  const motionContext = resolveKeyPoseMotionContext({
    scene: motionEditorState.scene,
    playback: motionEditorState.playback,
    keyPoseReferenceName: referenceName,
  });
  if (!motionContext) {
    return;
  }

  const didSave = await keyPoseStore.saveSceneObjectMotionKeyPoses({
    sceneID: motionContext.sceneID,
    referenceName: motionContext.referenceName,
    timelineIndex: motionContext.timelineIndex,
    keyPoses: [],
  });
  if (!didSave) {
    noticesStore.error(
      'Character swapped, but key poses could not be cleared from the scene.',
    );
  }
}
